import script from "./OtherAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtherAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./OtherAttachment.vue?vue&type=style&index=0&id=07aa139a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07aa139a"]])

export default __exports__